import React, { Component } from 'react';
import { BrowserRouter as Router } from 'react-router-dom'
import { Provider } from 'react-redux';
import Helmet from "react-helmet";
import MasterLayout from './masterlayout';
import store from '../store';

import 'getbase/css/styles.css';
import '../assets/style.css';
import '../style/index.css';

//01066691045

export default class App extends Component {


        render() {
            return (
                <div id="app">
                    <Helmet
                htmlAttributes={{lang: "en", amp: undefined}} 
                titleTemplate="مجلة حواء %s"
                titleAttributes={{itemprop: "name", lang: "ar"}}

                meta={[
                    // {name: "description", content: "Sunrise Resorts & Cruises"},
                    // {property: "og:type", content: "Website"},
                    // {name: "apple-mobile-web-app-capable", content: "yes"},
                    // {name: "apple-mobile-web-app-title", content: "Sunrise Resorts" },
                    // {name: "apple-mobile-web-app-status-bar-style", content: "translucent" },
                ]}
                link={[
                    // {rel: "canonical", href: ""},
                    // {rel: "apple-touch-icon", sizes: "144x144", href: "apple-icon-144x144.png"},
                    // {rel: "apple-touch-icon", sizes: "114x114", href: "apple-icon-114x114.png"},
                    // {rel: "apple-touch-icon", sizes: "72x72", href: "apple-icon-72x72.png"},
                    // {rel: "apple-touch-icon", sizes: "57x57", href: "apple-icon-57x57.png"},
                    // {rel: "apple-touch-startup-image", href: "/images/preloader.gif"},
                    // {rel: "stylesheet", href: "https://fonts.googleapis.com/css?family=Roboto:100,300,400,700"},
                    // {rel: "stylesheet", type: "text/css", href: "https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css"},
                    // {rel: "stylesheet", type: "text/css", href: "https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css"},

                ]}
                onChangeClientState={(newState) => console.log(newState)}
            >
                <meta content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0" name="viewport" />
                <meta name="description" content="مجلة حواء"/>
                <meta property="og:type" content="Website"/>
                <meta name="apple-mobile-web-app-capable" content="yes"/>
                <meta name="apple-mobile-web-app-title" content="مجلة حواء" />
                <meta name="apple-mobile-web-app-status-bar-style" content="translucent" />
                <link rel="canonical" href="https://app.hawaamagazine.com/"/>
                <link rel="apple-touch-icon" sizes="144x144" href="/apple-icon-144x144.png" />
                <link rel="apple-touch-icon" sizes="114x114" href="/apple-icon-114x114.png" />
                <link rel="apple-touch-icon" sizes="72x72" href="/apple-icon-72x72.png"/>
                <link rel="apple-touch-icon" sizes="57x57" href="/apple-icon-57x57.png"/>
                <link rel="apple-touch-startup-image" href="/logo.png"/>
                <link rel="icon" sizes="192x192" href="/logo.png" />
        </Helmet>
                    <Provider store={store()}>
                        <Router>
                            <MasterLayout />
                        </Router>
                    </Provider>
                </div>
            );
            }
}
                // <link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Roboto:100,300,400,700" />
                                    // <Route path="/home/:resort" component={Resort}/>
//   <!-- Apple -->
//     <meta name="apple-mobile-web-app-capable" content="yes" />
//     <meta name="apple-mobile-web-app-status-bar-style" content="black" />
//     <meta name="apple-mobile-web-app-title" content="Title" />
//     <link rel="apple-touch-icon" href="assets/img/apple_icon.png" />
//     <!-- Chrome -->
//     <meta name="mobile-web-app-capable" content="yes" />
//     <meta name="application-name" content="Title" />
//     <link rel="icon" sizes="192x192" href="assets/img/chrome_icon.png" />
//     <meta name="theme-color" content="#000000" />
//     <!-- Microsoft -->
//     <meta name="msapplication-tap-highlight" content="no" />
//     <meta name="msapplication-TileImage" content="assets/img/ms_icon.png" />
//     <meta name="msapplication-TileColor" content="#000000" />
//     <!-- Open Graph -->
//     <meta property="og:title" content="" />
//     <meta property="og:type" content="website" />
//     <meta property="og:url" content="" />
//     <meta property="og:image" content="" />
//     <meta property="og:description" content="" />
//     <meta property="og:locale" content="" />
//     <meta property="og:site_name" content="" />
//     <meta name="twitter:card" content="summary" />
//     <meta name="twitter:site" content="@" />
//     <meta name="twitter:title" content="" />
//     <meta name="twitter:description" content="" />
// <meta name="twitter:image" content="" />



// WEBPACK FOOTER //
// ./src/components/app.js